import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { SvgIcon } from 'components/SvgIcon';
import { cartService } from 'services/CartService';
import { IProductData } from 'interfaces/IProductData';
import Translate from 'components/Translate';

const styles = require('./locale.css');

interface IState extends IStateBase {
  cart: IProductData;
}

// tslint:disable-next-line:variable-name
export class Locale extends BaseComponent<IState, {}> {

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  address = () => {
    const { cart } = this.state;
    let address = '';

    if (cart.tickets.street) {
      address += cart.tickets.street + ',';
    }

    if (cart.tickets.number) {
      address += cart.tickets.number + '-';
    }

    if (cart.tickets.neighborhood) {
      address += cart.tickets.neighborhood + '-';
    }

    if (cart.tickets.city) {
      address += cart.tickets.city + ',';
    }

    if (cart.tickets.province) {
      address += cart.tickets.province + ',';
    }

    if (cart.tickets.cep) {
      address += cart.tickets.cep;
    }

    return address;
  }

  render() {

    if (!this.state) {
      return null;
    }

    const { cart } = this.state;
    return (
      <div className={styles.component}>
        <div className='schedule'>
          <h3 id='dateTime_label theme-icon' ><SvgIcon name='calendar' /> <Translate term='Data e Horário' /></h3>
          <span id='dateTime_content'><Translate term='Inicio:' /> {cart.tickets.eventDate}</span>
          <span id='dateTime_content'><Translate term='Término:' /> {cart.tickets.eventFinishDate}</span>
          <h3 id='place_Name' className='locale theme-icon'><SvgIcon name='pin_map' /> <Translate term='Endereço' /></h3>
          <span id='place_address' >
            {this.address()}
          </span>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Locale/index.tsx